<template lang="html">
  <div>
    <DashboardStatusLine v-if="status === 'empty'" warning>
      <IxRes>dlgCert.Status.Training.Empty</IxRes>
    </DashboardStatusLine>
    <DashboardStatusLine v-else-if="status === 'started'" warning>
      <IxRes>dlgCert.Status.Training.Started</IxRes>
    </DashboardStatusLine>
    <DashboardStatusLine v-else-if="status === 'neededFinished'">
      <IxRes>dlgCert.Status.Training.NeededFinished</IxRes>
    </DashboardStatusLine>
    <DashboardStatusLine v-else-if="status === 'finished'">
      <IxRes>dlgCert.Status.Training.Finished</IxRes>
    </DashboardStatusLine>
  </div>
</template>

<script>
import DashboardStatusLine from './DashboardStatusLine'

export default {
  components: {
    DashboardStatusLine
  },
  props: {
    status: String
  }
}
</script>

<style lang="scss" scoped>
</style>
